import moment from 'moment';

const DATE_FORMAT = 'MM/DD/YYYY';
const COMPACT_UTC_DATETIME_FORMATS = [
  'YYYYMMDDHHmmss',
  'YYYYMMDDHHmm',
  'YYYYMMDDHH',
  'YYYYMDDHHmmss',
  'YYYYMDDHHmm',
  'YYYYMDDHH',
];
const COMPACT_DATE_FORMATS = ['YYYYMMDD', 'YYYYMDD'];

export const formatTodayPaymentDate = datetime => {
  if (!datetime) {
    return null;
  }

  const value = String(datetime);

  const compactUtcDateTime = moment.utc(value, COMPACT_UTC_DATETIME_FORMATS, true);
  if (compactUtcDateTime.isValid()) {
    return compactUtcDateTime.local().format(DATE_FORMAT);
  }

  const compactDate = moment(value, COMPACT_DATE_FORMATS, true);
  if (compactDate.isValid()) {
    return compactDate.format(DATE_FORMAT);
  }

  const utcDateTime = moment.utc(datetime);
  return utcDateTime.isValid() ? utcDateTime.local().format(DATE_FORMAT) : null;
};

export default formatTodayPaymentDate;
